import fc24 from "./assets/fc24.jpeg";
import gtav from "./assets/gtav.png";
import minecraft from "./assets/minecraft.jpeg";
import nfs from "./assets/nfs.jpeg";
import spiderman2 from "./assets/spiderman2.jpeg";
import supermariogalaxy from "./assets/supermariogalaxy.jpg";

export const DUMMY_PRODUCTS = [
    {
        id: "p1",
        image: fc24,
        title: "EA Sports FC 24",
        price: 69.99,
        description:
            "Experience the thrill of the beautiful game in EA Sports FC 24, the latest installment in the iconic football simulation series. With enhanced graphics, realistic gameplay, and the inclusion of women's leagues, FC 24 brings you closer to the action than ever before. Build your ultimate team, compete in thrilling matches, and feel the energy of the stadium as you take your favorite clubs to glory."
    },
    {
        id: "p2",
        image: gtav,
        title: "Grand Theft Auto V",
        price: 24.99,
        description:
            "Step into the chaotic and vibrant world of Grand Theft Auto V, where you can live the life of a criminal mastermind in the sprawling city of Los Santos. With three unique protagonists, a massive open-world to explore, and an extensive online mode, GTA V offers endless opportunities for mayhem, heists, and high-speed chases. Whether you’re pulling off daring robberies or just cruising the streets, the world of GTA V is yours to conquer."
    },

    {
        id: "p3",
        image: minecraft,
        title: "Minecraft",
        price: 19.99,
        description:
            "Unleash your creativity and embark on endless adventures in Minecraft, the block-building phenomenon that has captivated millions. Explore vast, procedurally generated worlds filled with diverse biomes, hostile mobs, and hidden treasures. Whether you’re constructing monumental structures, surviving the harsh nights, or collaborating with friends in multiplayer mode, Minecraft offers limitless possibilities for players of all ages."
    },
    {
        id: "p4",
        image: nfs,
        title: "Need for Speed",
        price: 49.99,
        description:
            "Get ready for adrenaline-pumping, high-octane racing in Need for Speed, the ultimate driving experience. Race through stunning landscapes, from city streets to mountain passes, while evading the cops and outmaneuvering rivals. With a wide selection of customizable cars and various modes, including gripping story-driven campaigns and intense multiplayer showdowns, Need for Speed puts you in the driver’s seat for heart-racing action."
    },
    {
        id: "p5",
        image: spiderman2,
        title: "Marvel's Spider-Man 2",
        price: 79.99,
        description:
            "Swing into action as the web-slinging hero in Marvel's Spider-Man 2, the highly anticipated sequel to the critically acclaimed Spider-Man series. Join Peter Parker and Miles Morales as they face off against new villains in a thrilling open-world New York City. With breathtaking graphics, dynamic combat, and an emotionally charged storyline, Spider-Man 2 delivers an unparalleled superhero experience."
    },
    {
        id: "p6",
        image: supermariogalaxy,
        title: "Super Mario Galaxy",
        price: 19.99,
        description:
            "Embark on an interstellar adventure with Mario in Super Mario Galaxy, where the beloved plumber defies gravity across a multitude of planets and galaxies. Featuring innovative gameplay mechanics, stunning visuals, and a whimsical soundtrack, this classic title challenges you to rescue Princess Peach from Bowser’s clutches. Traverse unique levels, collect Power Stars, and experience one of the most imaginative entries in the Super Mario series."
    }
];
